import { render, staticRenderFns } from "./formDelete.vue?vue&type=template&id=0803e943&"
import script from "./formDelete.vue?vue&type=script&lang=js&"
export * from "./formDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports